import React, { useState, useEffect } from "react";
import { Button, Modal, Box, Typography, useMediaQuery } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getGlobals } from "../../Configs";
import axios from "axios";
import { fcheck_null_undefine_replace_empty } from "../../Utility/Utilitys";

const ReportModal = ({ sheetId }) => {
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const [reportData, setReportData] = useState([]);
  const baseURL = getGlobals().API_BASE_URL;
  const columns = [
    // { field: "D_ItmCd", headerName: "Item Code", width: 70 },
    { field: "ItmName", headerName: "Name", width: xMediaQuery ? 200 : 350 },
    { field: "BarCode", headerName: "Barcode", width: xMediaQuery ? 100 : 150 },
    {
      field: "MainGroup",
      headerName: "MainGroup",
      width: xMediaQuery ? 100 : 150,
    },
    {
      field: "Category",
      headerName: "Category",
      width: xMediaQuery ? 100 : 150,
    },
    { field: "Brand", headerName: "Brand", width: xMediaQuery ? 100 : 150 },
    {
      field: "D_CostPr",
      headerName: "Cost Price",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_PhyQty",
      headerName: "Phy Qty",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(3) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_PhyVal",
      headerName: "Phy Val",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_BookQty",
      headerName: "Book Qty",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(3) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_BookVal",
      headerName: "Book Val",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_VarQty",
      headerName: "Var Qty",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(3) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_VarVal",
      headerName: "Var Val",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_CancelledQty",
      headerName: "Cancelled",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_VoidQty",
      headerName: "Void",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_ReturnQty",
      headerName: "Return",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_AdjustQty",
      headerName: "Adj",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_PurchaseReturnQty",
      headerName: "PR",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
    {
      field: "D_SRQty",
      headerName: "SR",
      width: xMediaQuery ? 70 : 100,
      valueFormatter: ({ value }) =>
        value != null ? Number(value).toFixed(2) : "",
      align: "right",
      headerAlign: "right",
    },
  ];

  useEffect(() => {
    getCycPhyCountVariance();
  }, []);

  const getCycPhyCountVariance = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/CycPhyCountVariance`,
        fcheck_null_undefine_replace_empty({
          SheetId: sheetId,
        })
      );
      if (response?.status === 200) {
        setReportData(response?.data?.recordset);
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);

      // ✅ Extract error message from API response
      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";
    } finally {
      loader.style.display = "none";
    }
  };

  return (
    <Box sx={{ paddingY: 1, paddingX: 0 }} className="stock-detail">
      <div style={{ height: '75vh', width: "100%" }}>
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
          }}
          rows={reportData}
          getRowId={(v) => v.D_ItmCd}
          columns={columns}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      </div>
    </Box>
  );
};

export default ReportModal;
